import { createContext } from 'react';
var ChipGroupContextDefault = {
  chipItems: undefined,
  mode: undefined,
  handleOnRemove: undefined
};
export var ChipGroupContext = /*#__PURE__*/createContext(ChipGroupContextDefault);